import React, {  useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const TimeSheetsContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token)
        dispatch(getDataOnRequest(props.userAuth.users_access_token,'GetTimeSheets','SET_TIMESHEETS'))
    }, [dispatch, props.userAuth.users_access_token]);

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData,
    timesheets:state.timesheets.timesheets
  };
};

const composedTimeSheetsContainer = compose(connect(mapStateToProps), TimeSheetsContainer)
export default composedTimeSheetsContainer;

